const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/loop/$loopId/dashboard/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { insightsDeliverablesSearchSchema } from '@/lib/zod-schemas/insightsSearchSchema';
export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/dashboard')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(insightsDeliverablesSearchSchema)
});